export const SIGNING_MODE_SIGN_ONLY = "sign-only";
export const SIGNING_MODE_PHANTOM_EMBEDDED = "phantom-embedded-sign-and-send";
export const SIGNING_MODE_EMBEDDED_PRESIGN_SUBMIT = "embedded-wallet-presign-submit";
export const SIGNING_MODE_EMBEDDED_SIGN_ONLY = "embedded-wallet-sign-only";

export function getWalletSigningAddress(wallet) {
  return wallet?.account?.address?.toString?.() || "";
}

export function getWalletSigningMode(wallet) {
  if (wallet?.signingMode === SIGNING_MODE_EMBEDDED_SIGN_ONLY) return SIGNING_MODE_EMBEDDED_SIGN_ONLY;
  if (wallet?.signingMode === SIGNING_MODE_EMBEDDED_PRESIGN_SUBMIT) return SIGNING_MODE_EMBEDDED_PRESIGN_SUBMIT;
  if (wallet?.signingMode === SIGNING_MODE_PHANTOM_EMBEDDED) return SIGNING_MODE_PHANTOM_EMBEDDED;
  return SIGNING_MODE_SIGN_ONLY;
}

export function isEmbeddedSignOnlyMode(signingMode) {
  return signingMode === SIGNING_MODE_EMBEDDED_SIGN_ONLY;
}

export function isEmbeddedPresignSubmitMode(signingMode) {
  return signingMode === SIGNING_MODE_EMBEDDED_PRESIGN_SUBMIT || signingMode === SIGNING_MODE_PHANTOM_EMBEDDED;
}

export function isWalletReadyToSignTransaction(wallet) {
  const walletAddress = getWalletSigningAddress(wallet);
  if (!walletAddress) return false;
  if (isEmbeddedPresignSubmitMode(getWalletSigningMode(wallet))) {
    return typeof wallet?.signAndSendTransaction === "function";
  }
  return typeof wallet?.signTransaction === "function";
}
